/* ============================================================
   Upsell-tilbud i Upcart-kurven ("Tilbud til dig")
   Indlæses fra sections/label-config.liquid (alle sider).
   Henter /?sections=upcart-upsell (sections/upcart-upsell.liquid +
   snippets/cart-upsell.liquid) og viser tilbuddene lige under
   varerne i Upcart (.upcart-public-cart-items).
   Produkter vælges i Shopify-admin: Content > Metaobjects >
   "Upsell-tilbud (kurv)".
   En evt. gammel <div id="anew-upsell"> fra Upcarts Custom HTML
   skjules automatisk. Upcart-koden kan derfor fjernes fra Upcart.

   DIN GRATIS GAVE: Upcarts gave-vare (linjeegenskab
   __upcartRewardProduct) skjules i Upcarts vareliste og vises i
   stedet under overskriften "Din gratis gave" - mellem varerne og
   "Tilbud til dig". Fejler noget, viser Upcart gaven som normalt.
   Gaver fra abonnementsboksen på produktsiden (linjeegenskab
   _gratis_gave, se snippets/anew-abo-box.liquid) vises på samme måde.

   GAVER MED KNAP (2026-10-07): En gratis gave lægges ikke automatisk i
   kurven. Når kunden har gjort sig fortjent til den, vises den under
   "Din gratis gave" med knappen "Tilføj til kurven". Først ved tryk
   lægges den i kurven (egenskab _gratis_gave + _gave_kilde) og evt.
   rabatkode sættes på. Kilder:
   - Abonnementsboksen: kortets vare får egenskaberne _gave_variant,
     _gave_handle og _gave_kode, når den lægges i kurven.
   - Kurv-gaver over et beløb: metaobjektet "Gratis gave i kurven"
     (anew_kurv_gave) - gave, beløbsgrænse og til/fra. Prisen 0 kr.
     kommer fra Shopify-rabatten "Gratis Gave" (skift produkt også dér).
     OBS: Så længe Upcarts trin "Gratis gave" selv lægger Anew Dream i
     kurven, vises den som før uden knap. Fjern Anew Dream fra Upcarts
     trin, når dette tema publiceres, så knappen tager over.
   En gave, kunden ikke længere har ret til (varen er fjernet, eller
   beløbet er under grænsen), fjernes automatisk igen.
   GAVE-PRODUKT (2026-10-12): Abonnementsgaver er varianter af det skjulte
   produkt "Abonnement gratis gave" (handle abonnement-gratis-gave, se
   GAVE_HANDLE). For de varer vises variantens navn (fx "Anew Sovemaske")
   og billede i stedet for produktnavnet. Koden GAVE-ABONNEMENT giver 100%.
   TILKØB (2026-10-12): Varer fra de skjulte "(tilkøb)"-produkter (handle
   tilkob-...) har egen tilbudspris og får egenskaben _tilkob = handle på
   det produkt, de er købt til (snippets/anew-abo-box.liquid). Er det
   produkt ikke længere i kurven, fjernes tilkøbet (invalidTilkobKeys).

   HEMMELIGE TILBUD (2026-10-07): Ingen rabatkoder. Knappen lægger en
   variant fra det unlisted produkt "Hemmelige tilbud" (handle
   hemmelige-tilbud) i kurven med den skjulte egenskab _upsell. Prisen er
   variantens egen pris, så den står direkte på varen i kurv og checkout,
   og kundens egne rabatkoder virker som normalt.
   Scriptet fjerner tilbudsvarer, der er lagt i kurven uden knappen (ingen
   _upsell), eller hvis der ikke længere er et udløserprodukt i kurven
   (kortet #anew-upsell-map fra snippets/cart-upsell.liquid).
   Evt. gamle HEMMELIGT-TILBUD-rabatkoder fjernes fra kurven (syncCodes).
   decorateLines() sætter et lille "Hemmeligt tilbud"-mærke på linjen.
   DROPDOWNS (2026-10-08): Varer med størrelser/farver (betræk, sengesæt)
   vises på ét kort med en dropdown pr. option. Størrelsen forvælges ud fra
   dynen i kurven (fx 140x220). Udsolgte kombinationer kan ikke vælges.

   HURTIGERE OG ROLIGERE VISNING (2026-10-09):
   - Kurven (/cart.js) og tilbuddene (/?sections=upcart-upsell) hentes
     samtidig i stedet for efter hinanden.
   - Gave og tilbud tegnes i ét hug (venter højst 700 ms på tilbuddene),
     så kurven ikke hopper to gange.
   - Tilbud gemmes pr. kurv-indhold, så et kendt indhold vises med det samme.
   - Indholdet skrives kun om, når det faktisk har ændret sig (ingen
     blink i billeder ved antal-ændringer).
   - Gave-produkter hentes allerede ved sideindlæsning.
   - Nye bokse toner blødt frem (CSS i component-cart-upsell-secret.css).
   - Stylesheets indlæses én gang fra sections/label-config.liquid.
   ============================================================ */
(function () {
  if (window.__anewUpsellInitV2) return;
  window.__anewUpsellInitV2 = true;

  // Slår CSS-reglen til, der skjuler Upcarts egen gave-linje med det
  // samme (se component-cart-upsell.css). Fjernes igen, hvis kurven
  // ikke kan hentes, så gaven aldrig forsvinder helt.
  document.documentElement.classList.add('anew-gift-ready');

  var SECTION = 'upcart-upsell';
  var ITEMS_SELECTOR = '.upcart-public-cart-items';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var html = '';        // "Tilbud til dig" (fra temaets sektion)
  var giftHtml = '';    // "Din gratis gave" (bygges her ud fra kurven)
  var giftTitles = [];  // produktnavne på gave-linjer
  var boxGiftTitles = []; // produktnavne på gaver fra abonnementsboksen
  var cartKey = null;
  var lastCart = null;  // seneste /cart.js (bruges til rabat-visning pr. linje)
  var pending = null;
  var booting = false;
  var shownGift = '';   // sidst viste gave-HTML (til blød fremtoning)
  var shownOffer = '';  // sidst viste tilbuds-HTML
  var sectionCache = {}; // produkter i kurven -> { html, map }

  // Kurv-gaver, der kræver et minimumsbeløb (førpris, uden gaver).
  // Styres i Shopify admin: Indhold > Metaobjekter > "Gratis gave i kurven"
  // (anew_kurv_gave). Listen skrives ind på siden af
  // sections/label-config.liquid (<script id="anew-kurv-gaver">).
  var KURV_GAVER = [];
  try {
    var kgEl = document.getElementById('anew-kurv-gaver');
    if (kgEl) KURV_GAVER = JSON.parse(kgEl.textContent) || [];
  } catch (e) { KURV_GAVER = []; }
  // Gave-produkt med en variant pr. gave: vis variantens navn (2026-10-12).
  var GAVE_HANDLE = 'abonnement-gratis-gave';
  var products = {};     // handle -> produkt-JSON (/products/<handle>.js)
  var fetching = {};
  var offers = [];       // gaver kunden kan tilføje med knappen
  var rebuild = false;   // true = gave-kortene skal bygges igen (produktdata kom)
  var forcePaint = false; // true = tegn igen, selv om kurven er uændret

  // Egen container lige under varerne (id "anew-upsell-auto").
  // En evt. gammel <div id="anew-upsell"> fra Upcarts Custom HTML skjules.
  function hideLegacy() {
    var legacy = document.querySelectorAll('#anew-upsell');
    for (var j = 0; j < legacy.length; j++) {
      if (legacy[j].style.display !== 'none') legacy[j].style.display = 'none';
    }
  }

  function ensureContainer() {
    hideLegacy();

    var items = document.querySelector(ITEMS_SELECTOR);
    var all = document.querySelectorAll('#anew-upsell-auto');
    var c = all[0] || null;
    for (var i = 1; i < all.length; i++) all[i].remove();
    if (!items) return c;
    if (!c) {
      c = document.createElement('div');
      c.id = 'anew-upsell-auto';
    }
    if (items.nextElementSibling !== c) items.after(c);
    return c;
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function kr(cents) {
    var n = Number(cents);
    if (!isFinite(n)) n = 0;
    return Math.round(n / 100).toLocaleString('da-DK') + ' kr';
  }

  function isBoxGift(item) {
    return !!(item && item.properties && item.properties._gratis_gave);
  }

  function isGift(item) {
    return !!(item && item.properties && (item.properties.__upcartRewardProduct || item.properties._gratis_gave));
  }

  function props(item) {
    return (item && item.properties) || {};
  }

  // Beløb der tæller med til kurv-gaver: førpris på alle varer undtagen gaver.
  function qualifyingCents(cart) {
    var sum = 0;
    (cart.items || []).forEach(function (item) {
      if (isGift(item)) return;
      sum += item.original_line_price != null ? item.original_line_price : item.price * item.quantity;
    });
    return sum;
  }

  function inCart(cart, variantId) {
    return (cart.items || []).some(function (i) { return String(i.variant_id) === String(variantId); });
  }

  // Gaver kunden har ret til, men som ikke er i kurven endnu.
  function computeOffers(cart) {
    var list = [];
    var seen = {};
    (cart.items || []).forEach(function (item) {
      var p = props(item);
      if (!p._gave_variant || seen[p._gave_variant]) return;
      seen[p._gave_variant] = true;
      if (inCart(cart, p._gave_variant)) return;
      list.push({ variantId: String(p._gave_variant), handle: p._gave_handle || '', code: p._gave_kode || '', source: 'boks' });
    });
    var total = qualifyingCents(cart);
    KURV_GAVER.forEach(function (g) {
      if (seen[g.variantId] || total < g.minCents || inCart(cart, g.variantId)) return;
      list.push({ variantId: String(g.variantId), handle: g.handle, code: g.code || '', source: 'kurv' });
    });
    return list;
  }

  // Gaver fra knappen, som kunden ikke længere har ret til.
  function staleGiftKeys(cart) {
    var total = qualifyingCents(cart);
    var keys = [];
    (cart.items || []).forEach(function (item) {
      var p = props(item);
      if (!p._gratis_gave) return;
      var ok;
      if (p._gave_kilde === 'kurv') {
        var g = KURV_GAVER.filter(function (k) { return String(k.variantId) === String(item.variant_id); })[0];
        ok = !!g && total >= g.minCents;
      } else {
        ok = (cart.items || []).some(function (i) { return String(props(i)._gave_variant) === String(item.variant_id); });
      }
      if (!ok) keys.push(item.key);
    });
    return keys;
  }

  // Tilkøbspris-varer (handle tilkob-...) må kun ligge i kurven sammen med
  // det produkt, de er købt til (egenskaben _tilkob = produktets handle).
  var TILKOB_PREFIX = 'tilkob-';
  function invalidTilkobKeys(cart) {
    var items = cart.items || [];
    var keys = [];
    items.forEach(function (item) {
      if (!item.handle || item.handle.indexOf(TILKOB_PREFIX) !== 0) return;
      var parent = props(item)._tilkob;
      var ok = !!parent && items.some(function (o) { return o !== item && o.handle === parent; });
      if (!ok) keys.push(item.key);
    });
    return keys;
  }

  // silent = hentes i forvejen (ved sideindlæsning). Kurven tegnes kun igen,
  // hvis produktet faktisk bruges af en gave, der venter på data.
  function fetchProduct(handle, silent) {
    if (!handle || products[handle] || fetching[handle]) return;
    fetching[handle] = true;
    fetch(ROOT + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        products[handle] = p;
        // Byg gave-kortene igen ud fra den kurv, vi allerede har (ingen ny
        // hentning). Er kurven ikke hentet endnu, bruges data, når den kommer.
        var needed = offers.some(function (o) { return o.handle === handle; });
        if ((!silent || needed) && lastCart) {
          rebuild = true;
          load(lastCart);
        }
      })
      .catch(function () { fetching[handle] = false; });
  }

  function offerCard(o) {
    var p = products[o.handle];
    if (!p) { fetchProduct(o.handle); return ''; }
    var v = (p.variants || []).filter(function (x) { return String(x.id) === o.variantId; })[0] || (p.variants || [])[0];
    if (!v || v.available === false) return '';
    var price = v.price;
    // Gave-produktet: variantens navn og billede (fx "Anew Sovemaske")
    var isGaveProd = o.handle === GAVE_HANDLE;
    var name = isGaveProd && v.title && v.title !== 'Default Title' ? v.title : p.title;
    var src = isGaveProd && v.featured_image && v.featured_image.src ? v.featured_image.src : p.featured_image;
    var img = src ? String(src).replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
    return '<div class="cart-gift__card">' +
        '<a class="cart-upsell__media" href="' + esc(p.url || '#') + '">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(name) + '" width="80" height="80" decoding="async">' : '') +
        '</a>' +
        '<div class="cart-upsell__body">' +
          '<p class="cart-upsell__title">' + esc(name) + '</p>' +
          '<div class="cart-upsell__prices">' +
            '<s class="cart-upsell__old">' + kr(price) + '</s>' +
            '<strong class="cart-upsell__new">' + kr(0) + '</strong>' +
            '<span class="cart-gift__save">Spar ' + kr(price) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-upsell__button" data-gift-claim="' + esc(o.variantId) + '" data-gift-source="' + esc(o.source) + '" data-gift-code="' + esc(o.code) + '">Tilføj til kurven</button>' +
        '</div>' +
      '</div>';
  }

  function buildGift(cart) {
    giftTitles = [];
    boxGiftTitles = [];
    if (!cart || !cart.items) { giftHtml = ''; return; }
    var cards = '';
    cart.items.forEach(function (item) {
      if (!isGift(item) || !item.product_title) return;
      giftTitles.push(String(item.product_title).trim());
      if (isBoxGift(item)) boxGiftTitles.push(String(item.product_title).trim());
      var orig = item.original_line_price != null ? item.original_line_price : item.price * item.quantity;
      var fin = item.final_line_price != null ? item.final_line_price : orig;
      // Gave-koder trækker gavens pris 1 gang pr. ordre. Køber kunden også
      // samme vare, fordeler Shopify rabatten på begge linjer - totalen er
      // rigtig, men gave-linjen vises som gratis.
      if (isBoxGift(item) && fin > 0) {
        var sameDisc = 0;
        cart.items.forEach(function (o) {
          if (o.variant_id !== item.variant_id) return;
          var oo = o.original_line_price != null ? o.original_line_price : o.price * o.quantity;
          sameDisc += oo - (o.final_line_price != null ? o.final_line_price : oo);
        });
        if (sameDisc >= orig) fin = 0;
      }
      var save = orig - fin;
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      // Gave-produktet: variantens navn er gavens navn (fx "Anew Sovemaske")
      var name = item.product_title;
      if (item.handle === GAVE_HANDLE && variant) { name = variant; variant = ''; }
      cards +=
        '<div class="cart-gift__card">' +
          '<a class="cart-upsell__media" href="' + esc(item.url || '#') + '">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(name) + '" width="80" height="80" decoding="async">' : '') +
          '</a>' +
          '<div class="cart-upsell__body">' +
            '<p class="cart-upsell__title">' + esc(name) + (item.quantity > 1 ? ' x ' + item.quantity : '') + '</p>' +
            (variant ? '<p class="cart-upsell__text">' + esc(variant) + '</p>' : '') +
            '<div class="cart-upsell__prices">' +
              (save > 0 ? '<s class="cart-upsell__old">' + kr(orig) + '</s>' : '') +
              '<strong class="cart-upsell__new">' + kr(fin) + '</strong>' +
              (save > 0 ? '<span class="cart-gift__save">Spar ' + kr(save) + '</span>' : '') +
            '</div>' +
            '<span class="cart-gift__tag">Gratis gave</span>' +
          '</div>' +
        '</div>';
    });
    offers = computeOffers(cart);
    offers.forEach(function (o) { cards += offerCard(o); });
    giftHtml = cards
      ? '<div class="cart-upsell cart-gift"><p class="cart-upsell__heading"><span>Din gratis gave</span></p>' + cards + '</div>'
      : '';
  }

  // Skjul Upcarts egen gave-linje (kun når vores gave-kort er tegnet).
  // Gaver fra abonnementsboksen har ikke Upcarts gave-tag, så de
  // genkendes på produktnavn + prisen 0 kr i linjen.
  function hideUpcartGift(c) {
    var lis = document.querySelectorAll('.upcart-public-cart-item');
    var giftShown = !!(c && c.querySelector('.cart-gift__card'));
    var items = lastCart && lastCart.items ? lastCart.items : [];
    for (var i = 0; i < lis.length; i++) {
      var hide = false;
      // Kendes kurvlinjen, afgør den alene (en købt vare med samme navn
      // som en gave må ikke skjules). Ellers bruges navn + pris som før.
      var lineItem = giftShown ? itemForLi(lis[i], i, lis, items) : null;
      if (lineItem) {
        hide = isGift(lineItem);
      } else if (giftShown) {
        var title = lis[i].querySelector('.upcart-public-component-product-tile__product-title');
        var t = title ? title.textContent.trim() : '';
        if (lis[i].querySelector('.upcart-public-component-tag')) {
          hide = giftTitles.indexOf(t) !== -1 && /gave|gift/i.test(lis[i].textContent);
        }
        if (hide && !/(^|[^\d.,])0([.,]00)?\s?kr/i.test(lis[i].textContent) && items.filter(function (it) { return String(it.product_title).trim() === t && !isGift(it); }).length) {
          hide = false; // samme navn som en købt vare, og linjen er ikke 0 kr
        }
        if (!hide && boxGiftTitles.indexOf(t) !== -1) {
          hide = /(^|[^\d.,])0([.,]00)?\s?kr/i.test(lis[i].textContent);
        }
      }
      var want = hide ? 'none' : '';
      if (lis[i].style.display !== want) lis[i].style.display = want;
    }
  }

  // Hemmelige tilbud = varianter af det unlisted produkt "Hemmelige tilbud".
  var TILBUD_HANDLE = 'hemmelige-tilbud';
  var upsellMap = null;  // { tilbudsvariant-id: [udløser-produkt-id, ...] } fra temaet

  // Kortet fra temaet: [[tilbudsvariant-id, [udløser-id, ...]], ...]. Samme
  // variant kan stå i flere tilbud - udløserne lægges sammen.
  function parseUpsellMap(raw) {
    var out = {};
    var data;
    try { data = JSON.parse(raw || '[]'); } catch (e) { return out; }
    if (!Array.isArray(data)) return data || out;
    data.forEach(function (pair) {
      if (!pair || pair.length < 2) return;
      var key = String(pair[0]);
      var list = out[key] || (out[key] = []);
      (pair[1] || []).forEach(function (id) { if (list.indexOf(id) === -1) list.push(id); });
    });
    return out;
  }

  function isTilbud(item) {
    return !!item && item.handle === TILBUD_HANDLE;
  }

  // Tilbudsvarer der skal ud af kurven: lagt i kurven uden knappen, eller
  // uden et udløserprodukt i kurven.
  function invalidTilbudKeys(cart) {
    var keys = [];
    var items = cart.items || [];
    items.forEach(function (item) {
      if (!isTilbud(item)) return;
      if (!props(item)._upsell) { keys.push(item.key); return; }
      if (!upsellMap) return;
      var triggers = upsellMap[String(item.variant_id)];
      if (!triggers) { keys.push(item.key); return; }
      // Gaver tæller med som udløser (2026-10-09), ligesom i
      // snippets/cart-upsell.liquid, der viser tilbuddene. Fx udløser en
      // gratis Anew Dream tilbuddet på Anew Dream Betræk.
      var ok = items.some(function (other) {
        return !isTilbud(other) && triggers.indexOf(Number(other.product_id)) !== -1;
      });
      if (!ok) keys.push(item.key);
    });
    return keys;
  }

  // Find kurvlinjen (fra /cart.js) der hører til en Upcart-linje.
  function itemForLi(li, index, lis, items) {
    var titleEl = li.querySelector('.upcart-public-component-product-tile__product-title');
    var title = titleEl ? titleEl.textContent.trim() : '';
    if (lis.length === items.length && items[index] &&
        String(items[index].product_title).trim() === title) return items[index];
    var same = items.filter(function (it) { return String(it.product_title).trim() === title; });
    return same.length === 1 ? same[0] : null;
  }

  // Lille "Hemmeligt tilbud"-mærke på tilbudslinjerne i Upcart.
  function decorateLines() {
    var lis = document.querySelectorAll('.upcart-public-cart-item');
    var items = lastCart && lastCart.items ? lastCart.items : [];
    for (var i = 0; i < lis.length; i++) {
      var li = lis[i];
      var item = itemForLi(li, i, lis, items);
      var tag = li.querySelector('.anew-line-tag');
      if (item && isTilbud(item)) {
        if (!tag) {
          var pricing = li.querySelector('.upcart-public-component-product-tile__product-pricing');
          if (pricing) {
            tag = document.createElement('span');
            tag.className = 'anew-line-tag anew-line-price__tag';
            tag.textContent = 'Hemmeligt tilbud';
            pricing.appendChild(tag);
          }
        }
        if (!li.classList.contains('anew-tilbud-line')) li.classList.add('anew-tilbud-line');
      } else {
        if (tag) tag.remove();
        if (li.classList.contains('anew-tilbud-line')) li.classList.remove('anew-tilbud-line');
      }
    }
  }

  // ---------- Dropdowns (størrelse + farve) på tilbudskort ----------
  // Kortet har data-variants: [{id, o:[værdi pr. option], a:tilgængelig, p, c, s, sv, img}]
  function cardVariants(card) {
    if (!card.__variants) {
      try { card.__variants = JSON.parse(card.getAttribute('data-variants') || '[]'); } catch (e) { card.__variants = []; }
    }
    return card.__variants;
  }

  function normSize(str) {
    var m = String(str || '').match(/(\d{2,3})\s*x\s*(\d{2,3})/i);
    return m ? m[1] + 'x' + m[2] : '';
  }

  // Størrelsen på dynen (eller anden vare med mål) i kurven, fx "140x220".
  function cartSizes() {
    var items = lastCart && lastCart.items ? lastCart.items : [];
    var sizes = [];
    items.forEach(function (item) {
      if (isTilbud(item) || isGift(item)) return;
      var size = normSize(item.variant_title) || normSize(item.title);
      if (!size) return;
      // Dyner først
      if (/dyne/i.test(item.product_title)) sizes.unshift(size); else sizes.push(size);
    });
    return sizes;
  }

  // Opdater kortet ud fra dropdownsene. changed = index på den ændrede dropdown (-1 = start).
  function applySelection(card, changed) {
    var variants = cardVariants(card);
    if (!variants.length) return;
    var selects = Array.prototype.slice.call(card.querySelectorAll('.cart-upsell__select'));
    var vals = selects.map(function (sel) { return sel.value; });
    var idx = selects.map(function (sel) { return Number(sel.getAttribute('data-opt-index')); });

    function matches(v, upto) {
      for (var k = 0; k < selects.length; k++) {
        if (upto != null && k >= upto) break;
        if (v.o[idx[k]] !== vals[k]) return false;
      }
      return true;
    }

    var chosen = variants.filter(function (v) { return v.a && matches(v); })[0];
    if (!chosen) {
      // Kombinationen findes ikke / er udsolgt: behold det ændrede valg, skift resten
      chosen = variants.filter(function (v) {
        if (!v.a) return false;
        if (changed >= 0) return v.o[idx[changed]] === vals[changed];
        return true;
      })[0] || variants.filter(function (v) { return v.a; })[0];
      if (chosen) selects.forEach(function (sel, k) { sel.value = chosen.o[idx[k]]; vals[k] = sel.value; });
    }

    // Slå valg fra, der ikke kan købes med de foregående valg
    selects.forEach(function (sel, k) {
      Array.prototype.forEach.call(sel.options, function (opt) {
        var ok = variants.some(function (v) {
          if (!v.a || v.o[idx[k]] !== opt.value) return false;
          for (var m = 0; m < k; m++) { if (v.o[idx[m]] !== vals[m]) return false; }
          return true;
        });
        opt.disabled = !ok;
      });
    });

    var btn = card.querySelector('[data-upsell-add]');
    if (!chosen) {
      if (btn) { btn.disabled = true; btn.textContent = 'Udsolgt'; }
      return;
    }
    if (btn) {
      btn.setAttribute('data-upsell-add', chosen.id);
      if (btn.textContent === 'Udsolgt') btn.textContent = btn.getAttribute('data-label') || 'Læg i kurven';
      btn.disabled = false;
    }
    var oldEl = card.querySelector('.cart-upsell__old');
    var newEl = card.querySelector('.cart-upsell__new');
    var saveEl = card.querySelector('.cart-upsell__save');
    if (newEl) newEl.textContent = chosen.p;
    if (oldEl) { oldEl.textContent = chosen.c; oldEl.hidden = !(chosen.s > 0); }
    if (saveEl) { saveEl.textContent = 'Spar ' + chosen.sv; saveEl.hidden = !(chosen.s > 0); }
    var img = card.querySelector('.cart-upsell__media img');
    if (img && chosen.img && img.getAttribute('src') !== chosen.img) img.setAttribute('src', chosen.img);
  }

  // Ved visning: forvælg størrelsen der passer til dynen i kurven.
  function initCards(c) {
    var cards = c.querySelectorAll('.cart-upsell__card[data-variants]');
    if (!cards.length) return;
    var sizes = cartSizes();
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.__anewInit) continue;
      card.__anewInit = true;
      var btn = card.querySelector('[data-upsell-add]');
      if (btn) btn.setAttribute('data-label', btn.textContent.trim());
      var changed = -1;
      var selects = card.querySelectorAll('.cart-upsell__select');
      for (var k = 0; k < selects.length && changed < 0; k++) {
        var sel = selects[k];
        for (var n = 0; n < sizes.length && changed < 0; n++) {
          for (var o = 0; o < sel.options.length; o++) {
            if (normSize(sel.options[o].value) && normSize(sel.options[o].value) === sizes[n]) {
              sel.value = sel.options[o].value;
              changed = k;
              break;
            }
          }
        }
      }
      applySelection(card, changed);
    }
  }

  function onChange(e) {
    var sel = e.target.closest && e.target.closest('.cart-upsell__select');
    if (!sel) return;
    var card = sel.closest('.cart-upsell__card');
    if (!card) return;
    var selects = Array.prototype.slice.call(card.querySelectorAll('.cart-upsell__select'));
    applySelection(card, selects.indexOf(sel));
  }

  function paint() {
    var c = ensureContainer();
    if (!c) return;
    if (forcePaint || c.getAttribute('data-key') !== cartKey) {
      forcePaint = false;
      var next = (giftHtml || html) ? giftHtml + html : '';
      // Skriv kun om, når indholdet faktisk er ændret (ingen blink)
      if (c.__anewHtml !== next) {
        c.innerHTML = next;
        c.__anewHtml = next;
        // Bokse der ikke var vist før, toner blødt frem
        if (giftHtml && !shownGift) {
          var g = c.querySelector('.cart-gift');
          if (g) g.classList.add('anew-appear');
        }
        if (html && !shownOffer) {
          var o = c.querySelector('.cart-upsell:not(.cart-gift)');
          if (o) o.classList.add('anew-appear');
        }
        shownGift = giftHtml;
        shownOffer = html;
      }
      c.setAttribute('data-key', cartKey);
    }
    c.style.display = (giftHtml || html) ? '' : 'none';
    initCards(c);
    hideUpcartGift(c);
    decorateLines();
    if (!c.__anewBound) {
      c.__anewBound = true;
      c.addEventListener('click', onClick);
      c.addEventListener('change', onChange);
    }
  }

  function keyFromCart(cart) {
    if (!cart || !cart.items) return 'unknown-' + Date.now();
    return cart.items.map(function (i) { return i.variant_id + ':' + i.quantity + ':' + i.final_line_price; }).join(',') +
      '|' + (cart.discount_codes || []).map(function (d) { return d.code + ':' + d.applicable; }).join(',');
  }

  var sectionKey = null;
  function sectionKeyFromCart(cart) {
    if (!cart || !cart.items) return null;
    // Variant-id'er (ikke kun produkt-id'er): alle hemmelige tilbud er varianter
    // af samme produkt, så et nyt tilbud i kurven skal også hente tilbuddene igen.
    var ids = cart.items.map(function (i) { return i.variant_id; });
    ids.sort();
    return ids.join(',');
  }

  // Henter "Hemmelige tilbud" fra temaet. Resultat: { html, map }
  function fetchSection() {
    return fetch(ROOT + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var doc = new DOMParser().parseFromString(data[SECTION] || '', 'text/html');
        var block = doc.querySelector('.cart-upsell');
        if (block) {
          // Stylesheets er allerede indlæst fra sections/label-config.liquid
          var links = block.querySelectorAll('link');
          for (var i = 0; i < links.length; i++) links[i].remove();
        }
        var mapEl = doc.getElementById('anew-upsell-map');
        return { html: block ? block.outerHTML : '', map: mapEl ? mapEl.getAttribute('data-map') : null };
      });
  }

  function useSection(sec, sKey) {
    if (sec.map != null) {
      upsellMap = parseUpsellMap(sec.map);
      // Kortet kom nu - tjek om tilbudsvarer i kurven skal fjernes
      if (lastCart && invalidTilbudKeys(lastCart).length) setTimeout(loadFromServer, 0);
    }
    html = sec.html;
    sectionKey = sKey;
    if (sKey != null) sectionCache[sKey] = sec;
  }

  // secPromise = tilbuddene, hentet samtidig med kurven (kan mangle)
  function load(cart, secPromise) {
    if (cart && cart.items) lastCart = cart;
    var key = keyFromCart(cart);
    if (key === cartKey && !rebuild) { paint(); return; }

    // Produktdata til en gave kom efter kurven var tegnet: tegn igen
    if (rebuild) forcePaint = true;
    rebuild = false;
    buildGift(cart);
    var sKey = sectionKeyFromCart(cart);

    // a) Samme produkter som sidst: tilbuddene er uændrede
    if (sKey === sectionKey && !pending) {
      cartKey = key;
      paint();
      return;
    }

    // b) Kendt kurv-indhold: vis gemte tilbud med det samme
    if (sKey != null && sectionCache[sKey] && !pending) {
      useSection(sectionCache[sKey], sKey);
      cartKey = key;
      paint();
      return;
    }

    // c) Nyt indhold: vent kort på tilbuddene, så gave og tilbud
    //    tegnes samtidig. Kommer de ikke inden 700 ms, vises gaven først.
    if (pending === key) return;
    pending = key;
    var p = secPromise || fetchSection();
    var waited = setTimeout(function () {
      if (pending === key) { cartKey = 'gift:' + key; paint(); }
    }, 700);
    p.then(function (sec) {
      clearTimeout(waited);
      if (pending !== key) return; // en nyere kurv er på vej
      useSection(sec, sKey);
      cartKey = key;
      pending = null;
      paint();
    }, function () {
      clearTimeout(waited);
      if (pending !== key) return;
      pending = null;
      cartKey = key;
      paint();
    });
  }

  // Hent altid kurven fra Shopify (/cart.js). Upcarts egen kurv-hændelse
  // har et andet dataformat og bruges kun som signal til at opdatere.
  // Tilbuddene hentes samtidig, så der kun er én ventetid.
  var again = false;
  function loadFromServer() {
    if (booting) { again = true; return; }
    booting = true;
    var secPromise = fetchSection();
    secPromise.catch(function () {});
    fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var stale = staleGiftKeys(cart).concat(invalidTilbudKeys(cart)).concat(invalidTilkobKeys(cart));
        if (stale.length) {
          var updates = {};
          stale.forEach(function (k) { updates[k] = 0; });
          return fetch(ROOT + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          })
            .then(function (r) { return r.json(); })
            .then(function (newCart) {
              load(newCart);
              if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
              return syncCodes(newCart);
            });
        }
        load(cart, secPromise);
        return syncCodes(cart).then(function (changed) {
          if (changed && typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
        });
      })
      .then(done, function () {
        document.documentElement.classList.remove('anew-gift-ready');
        done();
      });
    function done() {
      booting = false;
      if (again) { again = false; loadFromServer(); }
    }
  }

  // Fjerner gamle HEMMELIGT-TILBUD-rabatkoder fra kurven (fra før 2026-10-07).
  // Kundens egne koder røres ikke. Returnerer et Promise. true = ændret.
  var CODE_PREFIX = 'HEMMELIGT-TILBUD-';
  var GIFT_PREFIX = 'GAVE-';
  var syncing = false;

  // Gave-koder, der hører til gaver i kurven lige nu (store bogstaver).
  function giftCodesInUse(cart) {
    var codes = [];
    var items = cart.items || [];
    items.forEach(function (item) {
      var p = props(item);
      if (!p._gratis_gave) return;
      var code = '';
      if (p._gave_kilde === 'kurv') {
        var g = KURV_GAVER.filter(function (k) { return String(k.variantId) === String(item.variant_id); })[0];
        code = g && g.code;
      } else {
        var main = items.filter(function (i) { return String(props(i)._gave_variant) === String(item.variant_id); })[0];
        code = main && props(main)._gave_kode;
      }
      if (code) codes.push(String(code).toUpperCase());
    });
    return codes;
  }
  function syncCodes(cart) {
    if (syncing || !cart || !cart.items) return Promise.resolve(false);

    // Hemmelige tilbud bruger ikke længere rabatkoder - gamle koder fjernes
    var wanted = [];

    var current = (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
    // Gave-koder (GAVE-...) må kun sidde på kurven, mens den tilhørende gave
    // ligger i kurven (lagt i med knappen). Ellers fjernes koden, så den ikke
    // kan bruges på en vare, kunden selv har lagt i kurven.
    var giftCodes = giftCodesInUse(cart);
    var dropGift = current.filter(function (c) { return c.indexOf(GIFT_PREFIX) === 0 && giftCodes.indexOf(c) === -1; });
    var others = current.filter(function (c) { return c.indexOf(CODE_PREFIX) !== 0 && dropGift.indexOf(c) === -1; });
    var ours = current.filter(function (c) { return c.indexOf(CODE_PREFIX) === 0; });

    var same = !dropGift.length && ours.length === wanted.length && wanted.every(function (c) { return ours.indexOf(c) !== -1; });
    if (same) return Promise.resolve(false);

    syncing = true;
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: others.concat(wanted).join(',') })
    })
      .then(function () { syncing = false; return true; },
            function () { syncing = false; return false; });
  }

  // Sætter en rabatkode på kurven uden at fjerne kundens egne koder.
  function addCode(code) {
    if (!code) return Promise.resolve();
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return String(d.code); });
        if (codes.some(function (c) { return c.toUpperCase() === code.toUpperCase(); })) return;
        codes.push(code);
        return fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') })
        });
      });
  }

  // Tving gave- og tilbudskortene til at blive tegnet forfra efter et klik,
  // så en knap aldrig bliver hængende i "Tilføjer..." (2026-10-09).
  function invalidatePaint() {
    forcePaint = true;
    var cc = document.getElementById('anew-upsell-auto');
    if (cc) cc.__anewHtml = null;
  }

  function onClaim(btn) {
    if (btn.disabled) return;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Lægger i kurven...';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{
        id: Number(btn.getAttribute('data-gift-claim')),
        quantity: 1,
        properties: { _gratis_gave: 'Ja', _gave_kilde: btn.getAttribute('data-gift-source') || 'kurv' }
      }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return addCode(btn.getAttribute('data-gift-code'));
      })
      .then(function () {
        invalidatePaint();
        if (typeof window.upcartRefreshCart === 'function') {
          window.upcartRefreshCart();
        } else {
          loadFromServer();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Kunne ikke tilføjes - prøv igen';
        setTimeout(function () { btn.textContent = originalText; }, 3000);
      });
  }

  function onClick(e) {
    var claim = e.target.closest && e.target.closest('[data-gift-claim]');
    if (claim) {
      e.preventDefault();
      e.stopPropagation();
      onClaim(claim);
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Tilføjer...';

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(btn.getAttribute('data-upsell-add')),
          quantity: 1,
          properties: (function () {
            return { _upsell: btn.getAttribute('data-upsell-offer') || 'kurv' };
          })()
        }]
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (res) { return res.json(); });
      })
      .then(function (cart) { return syncCodes(cart); })
      .then(function () {
        invalidatePaint();
        if (typeof window.upcartRefreshCart === 'function') {
          window.upcartRefreshCart();
        } else {
          loadFromServer();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Kunne ikke tilføjes - prøv igen';
        setTimeout(function () { btn.textContent = originalText; }, 3000);
      });
  }

  // 1) Upcart: opdatér hver gang kurven indlæses/ændres
  function subscribe() {
    if (typeof window.upcartSubscribeCartLoaded === 'function') {
      window.upcartSubscribeCartLoaded(function () { loadFromServer(); });
      return true;
    }
    return false;
  }
  if (!subscribe()) {
    var tries = 0;
    var t = setInterval(function () {
      if (subscribe() || ++tries > 50) clearInterval(t);
    }, 200);
  }

  // 2) Hent tilbuddene med det samme - og gave-produkterne i forvejen,
  //    så alt er klar, når kurven åbnes
  loadFromServer();
  KURV_GAVER.forEach(function (g) { fetchProduct(g.handle, true); });

  // 3) Upcart gen-tegner kurven - sørg for at tilbuddene altid står under varerne
  new MutationObserver(function () {
    hideLegacy();
    var items = document.querySelector(ITEMS_SELECTOR);
    if (!items) return;
    var c = document.getElementById('anew-upsell-auto');
    if (!c || items.nextElementSibling !== c || c.getAttribute('data-key') !== cartKey) {
      if (cartKey === null) { if (!booting) loadFromServer(); } else { paint(); }
    } else {
      hideUpcartGift(c);
      decorateLines();
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value'] });
})();
